import { Button, Menu, MenuItem, MenuTrigger, Text, type Theme } from "@hopper-ui/components";

import { Icon } from "@hopper-ui/icons";
import { forwardRef } from "react";
import { DocumentationThemes } from "./documentation-theme";

interface ColorSchemeSwitchProps {
    onThemeChange?: (theme: Theme) => void;
    theme: Theme;
    className?: string;
    text?: string;
}

const ThemeSwitch = ({ onThemeChange, theme, className, text }: ColorSchemeSwitchProps & { theme: Theme }) => {
    return (
        <MenuTrigger>
            <Button aria-label="Select theme" variant="ghost-secondary" className={className}>
                <Icon src16={ColorPaletteIcon} src24={ColorPaletteIcon} src32={ColorPaletteIcon} />
                {text && <Text>{text}</Text>}
            </Button>
            <Menu selectionMode="single" selectedKeys={[theme]}>
                {DocumentationThemes.map(t => (
                    <MenuItem
                        key={t}
                        id={t}
                        onAction={() => onThemeChange?.(t)}
                    >{`Change to ${t.charAt(0).toUpperCase() + t.slice(1)} Theme`}</MenuItem>
                ))}
            </Menu>
        </MenuTrigger>
    );
};

export default ThemeSwitch;

const ColorPaletteIcon = forwardRef<SVGSVGElement>((props, ref) => (
    <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        style={{ fill: "var(--hd-color-neutral-icon)" }}
        width="16px"
        height="16px"
        viewBox="0 0 24 24"
        {...props}
    >
        <g data-name="Layer 2">
            <g data-name="color-palette">
                <rect width="24" height="24" opacity="0" />
                <path d="M19.54 5.08A10.61 10.61 0 0 0 11.91 2a10 10 0 0 0-.05 20 2.58 2.58 0 0 0 2.53-1.89 2.52 2.52 0 0 0-.57-2.28.5.5 0 0 1 .37-.83h1.65A6.15 6.15 0 0 0 22 11.33a8.48 8.48 0 0 0-2.46-6.25zM15.88 15h-1.65a2.49 2.49 0 0 0-1.87 4.15.49.49 0 0 1 .12.49c-.05.21-.28.34-.59.36a8 8 0 0 1-7.82-9.11A8.1 8.1 0 0 1 11.92 4H12a8.47 8.47 0 0 1 6.1 2.48 6.5 6.5 0 0 1 1.9 4.77A4.17 4.17 0 0 1 15.88 15z" />
                <circle cx="12" cy="6.5" r="1.5" />
                <path d="M15.25 7.2a1.5 1.5 0 1 0 2.05.55 1.5 1.5 0 0 0-2.05-.55z" />
                <path d="M8.75 7.2a1.5 1.5 0 1 0 .55 2.05 1.5 1.5 0 0 0-.55-2.05z" />
                <path d="M6.16 11.26a1.5 1.5 0 1 0 2.08.4 1.49 1.49 0 0 0-2.08-.4z" />
            </g>
        </g>
    </svg>
));
